<template>
    <div class="menu">
        <h3 class="panel-title">实验分类
          <el-radio-group v-model="radio1" class="rowtab" @change="switc">
              <el-radio-button label="按章节" class="buttontab"></el-radio-button>
              <el-radio-button label="按知识点" class="buttontab"></el-radio-button>
          </el-radio-group>
        </h3>
          <!-- 知识点 -->
          <!-- el-tree方法 -->
        <div class="tree-el">
          <el-tree
              v-loading="loading"
              v-if="ischapter"
              :data="data"
              ref="treez"
              highlight-current
              :default-expanded-keys="[ this.getSubject ]"
              :props="defaultProps"
              node-key="id"
              accordion
              @node-click="handleOpen">
              <span class="custom-tree-node" slot-scope="{ node }">
                <span :title="node.label">{{ node.label }}</span>
              </span>
          </el-tree>
          <!-- 这里是userSubject为null的时候默认展示全部 -->
          <el-tree
              v-loading="loading"
              v-if="ischapter3"
              :data="data3"
              highlight-current
              :props="defaultProps3"
              node-key="id"
              accordion
              @node-click="handleOpen3">
              <span class="custom-tree-node" slot-scope="{ node }">
                <span :title="node.label">{{ node.label }}</span>
              </span>
          </el-tree>
            <!-- 章节 -->
          <el-tree
              v-loading="loading"
              v-if="ischapter2"
              :data="data2"
              ref="treej"
              highlight-current
              node-key="id"
              :default-expanded-keys="[ this.getSubject2 ]"
              :props="defaultProps2"
              accordion
              @node-click="handleOpen2">
              <span class="custom-tree-node" slot-scope="{ node }">
                <span :title="node.label">{{ node.label }}</span>
              </span>
          </el-tree>
        </div>
    </div>
</template>

<script>
import request from '@/utils/request'
  export default {
    data(){
        return{
          getType:0,
          getSubject:0,
          getSubject2:0,
          radio1:'',
          loading:false,
          ischapter:false,
          ischapter2:false,
          ischapter3:false,
          data:[{}],
          data2:[{}],
          data3:[{}],
          defaultProps: {
            children: 'children',
            label: 'chapterName'
          },
          defaultProps2: {
            children: 'children',
            label: 'chapterName'
          },
          defaultProps3: {
            children: 'children',
            label: 'chapterName'
          },
          firstMenu:[],
          secMenu:[],
          eduId:'',
          edutreeid:'',
          information:[],
        }
    },
    created(){
        this.getinfo();
        // this.getsad();
    },
    methods: {
      getsad(){
        alert(document.documentElement.clientWidth)
      },
      //获取info
      getinfo(){
        request({
          method:'get',
          url:'auth/info'
        }).then(res=>{
          if(res.userSubjectK == null){
            this.getSubject = 0
          }else{
            this.getSubject = res.userSubjectK.treeId
          }
          if(res.userSubjectC == null){
            this.getSubject2 = 0
          }else{
            this.getSubject2 = res.userSubjectC.treeId
          }

          if(res.userSubjectK !== null && res.userSubjectC !== null){
              if(res.userSubjectK.type == 0){
                this.radio1 = '按知识点';
                this.ischapter = true;
                this.ischapter2 = false;
                this.getTrees();
              }
          }else if(res.userSubjectK == null && res.userSubjectC == null){
                this.radio1 = '按知识点';
                this.ischapter = false;
                this.ischapter2 = false;
                this.ischapter3 = true;
                this.getTrees3();
          }else if(res.userSubjectK !== null){
                this.radio1 = '按知识点';
                this.ischapter = true;
                this.ischapter2 = false;
                this.getTrees();
          }else if(res.userSubjectC !== null){
                this.radio1 = '按章节';
                this.ischapter = false;
                this.ischapter2 = true;
                this.getChapterTrees();
          }
        })
      },
      //知识点和章节切换
      switc(value){
        if(value == "按知识点"){
            this.ischapter = true;
            this.ischapter2 = false;
            this.ischapter3 = false;
            this.getTrees();
            this.bus.$emit('switc',this.getSubject)
        }else{
            this.ischapter = false;
            this.ischapter2 = true;
            this.ischapter3 = false;
            this.getChapterTrees();
            this.bus.$emit('switc2',this.getSubject2)
        }
      },
      //通过知识点获取
      getTrees(){
          this.loading=true,
          request({
            url: 'api/trees/treesByStatus?'+'treeid=0',
            method: 'get'
          }).then(res=>{
            this.data = res.data;
            this.loading=false
            this.$nextTick(function(){
              this.$refs.treez.setCurrentKey(this.getSubject)
            })
          })
      },
      // userSubject 为null的时候展示
      getTrees3(){
          this.loading=true
          request({
            url: 'api/trees/treesByStatus?'+'treeid=0',
            method: 'get'
          }).then(res=>{
            this.data3 = res.data;
            this.loading=false
          })
      },
      //通过章节获取
      getChapterTrees(){
          this.loading=true,
          request({
            method:'get',
            url:'api/chaptertreesByStatus?'+'treeid=0',
          }).then(res=>{
            this.data2 = res.data
            this.loading=false
            this.$nextTick(function(){
              this.$refs.treej.setCurrentKey(this.getSubject2)
            })
          })
      },
      // 实验分类点击事件
      handleOpen(data,index) {
        this.bus.$emit("ificationA",data)
        this.eduId = index
      },
      handleOpen2(data,index) {
        this.bus.$emit("ificationA2",data)
        this.eduId = index
      },
      handleOpen3(data,index) {
        this.bus.$emit("ificationA3",data)
        this.eduId = index
      },
      // 实验分类关闭事件
      handleClose(key, keyPath) {
      },
      handleClose2(key, keyPath) {
      }
    }
  }
</script>
<style scoped>
    @import '../styles/pad.css';
    @import '../styles/treeStyle.css';
  @media screen and (min-width:1025px) and (max-width:1366px){

  }
  @media screen and (min-width:1366px) and (max-width:1440px){
  }
  @media screen and (min-width:1441px) and (max-width:1600px){
  }
  @media screen and (min-width:1601px) and (max-width:1920px){
  }
  @media screen and (min-width:1921px) and (max-width:2048px){
  }
  @media (min-width:2049px){
  }
</style>




// WEBPACK FOOTER //
// src/components/myComponents/Menu.vue